
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { InventoryStockTaking, InventoryStockTakingsUiClient } from '../../../backend/backendapi';
import { handleError, initClient } from '../../../../api';
import Spinner from '../../../util/Spinner';
import InventoryStockTakingStore from '../../../../stores/InventoryStockTakingStore';
import StockTakingEditor from './StockTakingEditor';

@Component({
  components: {
    Spinner,
    StockTakingEditor, 
  },
})
export default class StockTakingEditModal extends Vue {
  readonly store = new InventoryStockTakingStore();
  stockTaking: InventoryStockTaking | null = null;
  isNew: boolean = false;
  saving = false;

  //api
  private readonly api = initClient(InventoryStockTakingsUiClient);

  public open(stockTaking: InventoryStockTaking, isNew: boolean): void {
    this.stockTaking = InventoryStockTaking.fromJS(stockTaking); //deep copy for edit
    this.isNew = isNew;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  async save(): Promise<void> {
    if (!this.stockTaking) {
      return;
    }

    this.saving = true;
    try {
      let res: InventoryStockTaking;
      if (this.isNew) {
        res = (await this.api.add([this.stockTaking]))[0];
      } else {
        res = await this.api.update(this.stockTaking.id, this.stockTaking);
      }
      this.$toasted.info(this.$t('txtSaved').toString());
      this.store.remember(res);
      this.dismiss();
      this.stockTaking = null;
      this.isNew = false;
    } catch (error) {
      handleError(this.$toasted, this.$i18n, error);
    } finally {
      this.saving = false;
    }
  }
}
